import AppRouter from './pages/AppRouter';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <div className="bg-bg min-h-screen font-sans">
        <AppRouter />
      </div>
    </HelmetProvider>
  );
}

export default App;
